var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-template',[_c('mould-info',{ref:"loanMoneyInfo",staticClass:"loan-money",attrs:{"id":"mainBox1","data-list":_vm.loanMoneyInfoList},on:{"iconClick":_vm.handleClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }